
export const patientConnectUrl = {
    base: "https://app.longboat.com",
    rel: "/api/v1/AuraBiosciences/1/patient_connect",
    get absolutePath() {
        return this.base + this.rel;
    },
}

export const patientConnectHeaders = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    //'Authorization': '',
}

export const gMapConsentCookieKey = "gMapConsentCookie";
export const gMapConsentCookieExpiryTimeInMins = 10;
export const googleMapApiKey = process.env.VUE_APP_GOOGLE_MAPS_API_KEY || '';
export const googleMapUrl = `https://maps.googleapis.com/maps/api/js?key=${googleMapApiKey}`;

// Animation
export const isPageAnimationEnabled = true;

// Login Page Style
export const isDefaultStyle = false; // true or false

//Images
export const logoPath = "logo.png";

//Google Analytics
//Pendo Analytics
export const pendoKey =  process.env.VUE_APP_PENDO_API_KEY;
export const studyURL = "au011301.longboat.com";
export const sponsorName = "Aura-Biosciences";
export const studyId = "AURA467";
export const AppType = "PRW";
export const pendoAccountName = studyId + '_' + AppType;

// Authentication
export const cookieExpiryTimeInMins = 20;
export const passwords = [{
    key: "pass", // key used for storing this password in cookie
    value: String(process.env.VUE_APP_PASSWORD),// password
    toRoute: "/", // go to this route/url after successful authentication
},];

// i18n localisation configuration
export const defaultLocale = "en";
export const supportedLocales = [
    "en",
    
    /*"bd",
    "bf",
    "cs",
    "da",
    "de",
    "el",
    "es",
    "fc",
    "fr",
    "it",
    "ko",
    "nl",
    "ru",
    "sp",*/
];

// Google map study Sites
export let gMapOptions = {
    center: {
        lat: 33.9466277,
        lng: -84.3320862,
    },
    scrollwheel: false,
    zoom: 10,
    styles: [{
        "featureType": "all",
        "elementType": "geometry.fill",
        "stylers": [{
            "weight": "2.00"
        }]
    },
    {
        "featureType": "all",
        "elementType": "geometry.stroke",
        "stylers": [{
            "color": "#9c9c9c"
        }]
    },
    {
        "featureType": "all",
        "elementType": "labels.text",
        "stylers": [{
            "visibility": "on"
        }]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [{
            "color": "#f2f2f2"
        }]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry.fill",
        "stylers": [{
            "color": "#ffffff"
        }]
    },
    {
        "featureType": "landscape.man_made",
        "elementType": "geometry.fill",
        "stylers": [{
            "color": "#ffffff"
        }]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [{
            "visibility": "off"
        }]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [{
            "saturation": -100
        },
        {
            "lightness": 45
        }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry.fill",
        "stylers": [{
            "color": "#eeeeee"
        }]
    },
    {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [{
            "color": "#7b7b7b"
        }]
    },
    {
        "featureType": "road",
        "elementType": "labels.text.stroke",
        "stylers": [{
            "color": "#ffffff"
        }]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [{
            "visibility": "simplified"
        }]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [{
            "visibility": "off"
        }]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [{
            "visibility": "off"
        }]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [{
            "color": "#46bcec"
        },
        {
            "visibility": "on"
        }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [{
            "color": "#c8d7d4"
        }]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [{
            "color": "#070707"
        }]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.stroke",
        "stylers": [{
            "color": "#ffffff"
        }]
    }
    ]
}
export let getSites = (googleMapObj, mapObj) => {
    let icon = {
        url: "/map.png",
    };
    let sites = [];

    var newsites = [

              /*Australia Study Center */
        
        {
            "title": "Centre for Eye Research Australia",
            "lat": -37.808785690637436,
            "lng": 144.97608991244695,
            "address": "32 Gisborne St, Level 7, East Melbourne Victoria 3002"
        },

        {
            "title": "Terrace Eye Institute",
            "lat": -27.464277,
            "lng": 153.026631,
            "address": "87 Wickham Terrace, Queensland, Spring Hill, 4000, Australia"
        },

            /*Austria Study Center */
        {
            "title": "Medizinische Universitat Wien",
            "lat": 48.2333,
            "lng": 16.35,
            "address": "Klinik für Augenheilkunde und Optometrie, Währinger Gürtel 18-20, Wien, Wien, 1090, Austria"
        },
        
           /*UK Study Center */
        {
            "title": "Moorfields Eye Hospital",
            "lat": 51.52762868949568, 
            "lng": -0.09005429031589464,
            "address": "Clinical Trials Pharmacy, Pharmacy Ground Floor  162 City Road  Moorfields Eye Hospital, London, EC1V 2PD, UK"
        },
        {
            "title": "NHS Foundation Trust - Royal Hallamshire Hospital",
            "lat": 53.37926057121932, 
            "lng": -1.4922498581466992,
            "address": "Glossop Road, Sheffield, S10 2JF, UK"
        },
                 /*Canada Study Center */
        {
            "title": "Centre Hospitalier de l'Universite Laval (CHUL)",
            "lat": 46.7846,
            "lng": -71.2884,
            "address": "2705 Boulevard Laurier D2-50 , Quebec City, G1S 4L8 Canada"
        },

                 /*Germany Study Center */
         {
            "title": "Klinikum der LMU Muenchen",
            "lat": 48.1500,
            "lng": 11.5833,
            "address": "Mathildenstrasse 8 Augenklinik und Poliklinik, Bayern, Muenchen, 80336, Germany"
        },

        {
            "title": "Universitätsklinikum Tübingen",
            "lat": 48.5226,
            "lng": 9.0556,
            "address": "Augenklinik, Elfriede-Aulhorn-Straße 7, Baden-Württemberg, Tübingen, 72076, Germany"
        },
            
                 /*Israel Study Center */
        {
            "title": "Hadassah Medical Center, Ein-Karem",
            "lat": 31.7683,
            "lng": 35.2170,
            "address": "Ophtalmology, Kiryat Hadassah, Yerushalayim, Jerusalem, 9112001, Israel"
        },

        {
            "title": "The Chaim Sheba Medical Center",
            "lat": 32.1167,
            "lng": 34.8333,
            "address": "Ophtalmology, Tel-Hashomer, HaMerkaz, Tel-Hashomer, 5265601, Israel"
        },

                 /*Italy Study Center */

        {
            "title": "AOU Careggi",
            "lat": 43.7793,
            "lng": 11.2486,
            "address": " Largo Giovanni Alessandro Brambilla, 3, Firenze, 50134, Italy"
        },

        {
            "title": "Universita'Cattolica Del Sacro Cuore - UNICATT",
            "lat": 41.9028,
            "lng": 12.4964,
            "address": "Oculistica, Largo Agostino Gemelli, 8, Roma, Roma, 00168, Italy"
        },

        {
            "title": "Ospedale Fatebenefratelli e Oftalmico, ASST Fatebenefratelli Sacco",
            "lat": 45.4773,
            "lng": 9.1815,
            "address": "U.O. Clinica Oculistica, Via G.B. Grassi, 74 Università di Milano, Milano, Milano, 20157, Italy"
        },

        /*
        {
            "title": "Terrace Eye Centre",
            "lat": -27.464319123965222,
            "lng": 153.02677361204744,
            "address": "87 Wickham Terrace, Spring Hill, Queensland 4000"
        },
        {
            "title": "Medizinische Universität Wien",
            "lat": 48.22078463576815,
            "lng": 16.346790539567756,
            "address": "Währinger Gürtel 18-20, 1090 Wien"
        },
        {
            "title": "Medizinische Universität Graz",
            "lat": 47.070865,
            "lng": 15.438674,
            "address": "Auenbruggerplatz 4, Steiermark, Graz, 8036"
        },
        */
        {
            "title": "UZ Leuven",
            "lat": 50.879844,
            "lng": 4.700518,
            "address": "Ophthalmology, Herestraat 49, Vlaams Brabant, Leuven, 3000, Belgium"
        },
        /*
        {
            "title": "Alberta Health Services (AHS) - Tom Baker Cancer Centre",
            "lat": 51.0447,
            "lng": -114.0719,
            "address": "1331 29 St NW, Calgary, AB T2N 4N2"
        },
        {
            "title": "Centre Hospitalier de l'Universite Laval (CHUL)",
            "lat": 46.7846,
            "lng": -71.2884,
            "address": "2705 Boulevard Laurier, Quebec City, G1S 4L8"
        },
        {
            "title": "Fakultni Thomayerova nemocnice",
            "lat": 50.0136,
            "lng": 14.4286,
            "address": "Videnska 800, Praha 4, 140 59"
        },
        {
            "title": "Fakultni nemocnice Ostrava",
            "lat": 49.8346,
            "lng": 18.2820,
            "address": "17. listopadu 1790, Ostrava-město, 708 52"
        },
        */
        {
            "title": "Ustredni vojenska nemocnice - Vojenska fakultni nemocnice Praha",
            "lat": 50.0675,
            "lng": 14.4344,
            "address": "U vojenske nemocnice 1200, Praha 6, 169 02"
        },

        {
            "title": "Fakultni Thomayerova nemocnice",
            "lat": 50.03064876138572, 
            "lng":  14.456764742081825,
            "address": "Videnska 800, Praha 4, 140 59, Czech Republic"
        },
        {
            "title": "Fakultni nemocnice Plzen",
            "lat": 49.7476,
            "lng": 13.3776,
            "address": "alej Svobody 923/80, alej Svobody 923/80, Plzen, 323 00"
        },
        {
            "title": "Universitätsklinikum Schleswig-Holstein ",
            "lat": 53.83852267344161, 
            "lng": 10.70309771595948,
            "address": "Klinik für Augenheilkunde, Ratzeburger Allee 160 Haus V30, Schleswig-Holstein, Lübeck, 23538"
        },
        {
            "title": "Charité – Universitätsmedizin Berlin KöR",
            "lat": 52.443904747691874,  
            "lng": 13.323427655300003,
            "address": "Klinik für Augenheilkunde, Hindenburgdamm 30, Lichterfelde, Berlin, 12203"
        },
        /*
        {
            "title": "Rigshospitalet",
            "lat": 55.6946,
            "lng": 12.5674,
            "address": "Inge Lehmanns Vej 8  Entrance 8  7th Floor, Capital, Copenhagen, 2100"
        },
        {
            "title": "Aarhus University Hospital",
            "lat": 56.1697,
            "lng": 10.2029,
            "address": "Palle Juul-Jensens Boulevard 99, Aarhus, 8000"
        },
        {
            "title": "Helsinki University Central Hospital",
            "lat": 60.1900,
            "lng": 24.9056,
            "address": "Haartmaninkatu 4,Etelä-Suomen lääni, Helsinki, 00290"
        },
        {
            "title": "Centre Hospitalier Universitaire de Nice",
            "lat": 43.7102,
            "lng": 7.2619,
            "address": "30 Voie Romaine, Provence-Alpes-Côte-d'Azur, Nice, 06001"
        },
        {
            "title": "Universitätsklinikum Schleswig-Holstein Klinik für Augenheilkunde",
            "lat": 54.3256,
            "lng": 10.1228,
            "address": "Ratzeburger Allee 160  Haus V30, Schleswig-Holstein, Lübeck, 23538"
        },
        {
            "title": "Charité – Universitätsmedizin Berlin KöR",
            "lat": 52.5200,
            "lng": 13.4050,
            "address": "Hindenburgdamm 30,Lichterfelde, Berlin, 12203"
        },
        {
            "title": "University Hospital Hamburg- Eppendorf",
            "lat": 53.5922,
            "lng": 10.0006,
            "address": "Martinistrasse 52,Eppendorf  Klinik und Poliklinik für Augenheilkunde, Hamburg, 20246"
        },
        {
            "title": "Center of Ophthalmology, University of Cologne",
            "lat": 50.9271,
            "lng": 6.9285,
            "address": "Kerpener Str. 62, Nordrhein-Westfalen, Cologne, 50937"
        },
        {
            "title": "Mitera Hospital",
            "lat": 37.9780,
            "lng": 23.7619,
            "address": "Erythrou Stavrou 6, Marousi, 151 23"
        },
        {
            "title": "Royal Victoria Eye & Ear Hospital",
            "lat": 53.33266666017265,
            "lng": -6.256362300277403,
            "address": "Adelaide Road, Dublin 2, D02 XK51"
        },
        {
            "title": "AOU di Padova",
            "lat": 45.4064,
            "lng": 11.8778,
            "address": "Via Giustiniani, 2, Padova, 35128"
        },
        {
            "title": "Istituto Nazionale dei Tumori, Fondazione IRCCS",
            "lat": 45.47468406767798,
            "lng": 9.232219225952095,
            "address": "Via Giacomo Venezian 1, 1, Milano, 20133"
        },
        {
            "title": "Gangnam Severance Hospital, Yonsei University Health System",
            "lat": 37.5244,
            "lng": 127.0276,
            "address": "211 Eonju-ro, Gangnam-gu, Seoul, 06273"
        },
        {
            "title": "Severance Hospital, Yonsei University Health System",
            "lat": 37.5244,
            "lng": 127.0276,
            "address": "50-1 Yonsei-ro, Seodaemun-gu, Seoul, 03722"
        },
        */    

             /* Netherlands Study Center */
          
        {
            "title": "Erasmus MC",
            "lat": 51.9174,
            "lng": 4.4844,
            "address": "Dr. Molewaterplein 40, Zuid-Holland, Rotterdam, 3015 GD, Netherlands"
        },
        {
            "title": "Leids Universitair Medisch Centrum (LUMC)",
            "lat": 52.1601,
            "lng": 4.4970,
            "address": "Albinusdreef 2 LUMC, Zuid-Holland, Leiden, 2333 ZA, Netherlands"
        },  
          
            /* Spain Study Center */  
        {
            "title": "CHUS – H. Clinico U. de Santiago",
            "lat": 42.8726,
            "lng": -8.5446,
            "address": "Rua da Choupana S/N, A Coruña, Santiago de Compostela, 15076, Spain"
        },
        {
            "title": "Hospital Universitario de Bellvitge",
            "lat": 41.3496,
            "lng": 2.0733,
            "address": "Oftalmología, Hospital Universitario de Bellvitge, Barcelona, 08907, Spain"
        },

             /* New Zealand Study Center */  
           {
            "title": "EyeOne",
            "lat": -36.873888 ,
            "lng": 174.780804,
            "address": "8 Saint Marks Road, Remuera, Auckland 1050, New Zealand"
        },



        /*
        {
            "title": "Hospital Universitario Y Politécnico La Fe",
            "lat": 39.4933,
            "lng": -0.3946,
            "address": "Avinguda de Fernando Abril Martorell, 106, Valencia, 46026"
        },
        {
            "title": "Moorfields Eye Hospital",
            "lat": 51.5246,
            "lng": -0.0889,
            "address": "Pharmacy, Ground Floor  162 City Road  Moorfields Eye Hospital, London, EC1V 2PD"
        },
        {
            "title": "Nhs Foundation Trust - Royal Hallamshire Hospital",
            "lat": 53.3816,
            "lng": -1.4906,
            "address": "Glossop Road, South Yorkshire, Sheffield, S10 2JF"
        },
        {
            "title": "Liverpool University Hospital Foundation Trust",
            "lat": 53.4084,
            "lng": -2.9786,
            "address": "Liverpool University Hospital Foundation Trust  Clinical Eye Research Centre  St Paul's Eye Unit, Liverpool, L7 8XP"
        },
        */

        /** United States */
        {
            "title": "Stanford University School of Med",
            "lat": 37.4293,
            "lng": -122.1680,
            "address": "Byers Eye Institute, 2452 Watson Court, Palo Alto, California, 94303, USA"
        },
        {
            "title": "Retina Associates of Florida, PA",
            "lat": 27.9372,
            "lng": -82.4853,
            "address": "602 S. MacDill Ave, Tampa, Florida, 33609, USA"
        },
        {
            "title": "W.K. Kellogg Eye Center - University of Michigan",
            "lat": 42.2821,
            "lng": -83.7289,
            "address": "1000 Wall St, Ann Arbor, Michigan, 48105, USA"
        },
        {
            "title": "Tennessee Retina, PC (RCA Network site)",
            "lat": 36.1595,
            "lng": -86.7941,
            "address": "345 23rd Avenue North, Suite 350, Nashville, Tennessee, 37203, USA"
        },
        {
            "title": "Texas Retina Associates",
            "lat": 32.8759,
            "lng": -96.7692,
            "address": "9600 N Central Expressway, Suite 100, Dallas, Texas, 75231, USA"
        },
        {
            "title": "Retina Consultants of Texas",
            "lat": 29.7076,
            "lng": -95.4719,
            "address": "4460 Bissonnet Street, Suite 200, Bellaire, Texas, 77401, USA"
        },
        {
            "title": "Massachusetts Eye and Ear",
            "lat": 42.3612,
            "lng": -71.0694,
            "address": "243 Charles Street, 12th Floor, Boston, Massachusetts, 02114, USA"
        },
        {
            "title": "Retina Consultants of Carolina",
            "lat": 34.8233,
            "lng": -82.3992,
            "address": "1126 Grove Road, Greenville, South Carolina, 29605, USA"
        },
        {
            "title": "University of Wisconsin Madison",
            "lat": 43.0761,
            "lng": -89.4125,
            "address": "2880 University Avenue, Madison, Wisconsin, 53705, USA"
        },
        {
            "title": "Tufts Medical Center",
            "lat": 42.3496,
            "lng": -71.0639,
            "address": "800 Washington Street, Suite 450, Boston, Massachusetts, 02111, USA"
        },
        
        {
            "title": "Duke Eye Center",
            "lat": 35.9993,
            "lng": -78.9392,
            "address": "2351 Erwin Road, Durham, North Carolina, United States"
        },
        
        {
            "title": "Mayo Clinic",
            "lat": 44.0207,
            "lng": -92.4699,
            "address": "611 B Guggenheim, 200 1st street, SW, Rochester, Minnesota, 55905, USA"
        },
        {
            "title": "Nebraska Medicine’s Truhlsen Eye Institute",
            "lat": 41.2553,
            "lng": -95.9760,
            "address": "3902 Leavenworth St, Omaha, Nebraska, 68105, USA"
        },
        {
            "title": "Retinal Consultants Medical Group, Inc. (RCA Network site)",
            "lat": 38.6019,
            "lng": -121.4183,
            "address": "3 Parkcenter Dr., Suite 100, Sacramento, California, 95825, USA"
        },
        {
            "title": "Emory Eye Center",
            "lat": 33.7925,
            "lng": -84.3224,
            "address": "1365 Clifton Rd B, Atlanta, Georgia, 30322, USA"
        },
        {
            "title": "Associated Retinal Consultants (ARC) P.C.",
            "lat": 42.5076,
            "lng": -83.1669,
            "address": "3555 West 13 Mile Road, Suite LL-20, Royal Oak, Michigan, 48073, USA"
        },
        {
            "title": "Austin Retina Associates - Ophthalmology/Retina (RCA Network site)",
            "lat": 30.3066,
            "lng": -97.7444,
            "address": "801 West 38th Street, Suite 200, Austin, Texas, 78705, USA"
        },
        {
            "title": "Retina Consultants of Alabama",
            "lat": 33.4899,
            "lng": -86.7913,
            "address": "700 South 18th St, Suite 707, Birmingham, Alabama, 35223, USA"
        },
        {
            "title": "Shields & Shields, PC",
            "lat": 39.9457,
            "lng": -75.1555,
            "address": "840 Walnut Street, Suite 1140, Philadelphia, Pennsylvania, 19107, USA"
        },
        {
            "title": "Retina Associates of South Texas, P.A.",
            "lat": 29.5474,
            "lng": -98.5859,
            "address": "9910 Huebner Rd, Suite 100, San Antonio, Texas, 78240-1375, USA"
        },
        {
            "title": "Dean McGee Eye Institute",
            "lat": 35.4804,
            "lng": -97.5299,
            "address": "608 Stanton L Young Blvd, Suite 338, Oklahoma City, Oklahoma, 73104, USA"
        },
        {
            "title": "Retina Associates of Utah (RCA Network site)",
            "lat": 40.6659,
            "lng": -111.8766,
            "address": "5169 S. Cottonwood Street, Building 2, Suite 630, Salt Lake City, Utah, 84107, USA"
        },
        /*
        {
            "title": "Univ of Tennessee Hamilton Eye Institute",
            "lat": 35.1441,
            "lng": -90.0512,
            "address": "930 Madison Ave, Suite 400, Memphis, Tennessee, 38103, USA"
        },
        {
            "title": "The University of Tennessee Health Science Center, Hamilton Eye Institute",
            "lat": 35.1441,
            "lng": -90.0512,
            "address": "930 Madison Ave, Suite 200, Memphis, Tennessee, 38163, USA"
        },
        {
            "title": "University of Rochester - Flaum Eye Institute",
            "lat": 43.1206,
            "lng": -77.6316,
            "address": "210 Crittenden Blvd, Floor 3, Rochester, New York, 14642, USA"
        },
        */
        {
            "title": "UT, Southwestern Medical Center",
            "lat": 32.8140,
            "lng": -96.8395,
            "address": "5323 Harry Hines Blvd, Dallas, Texas, 75390-9057, USA"
        },
        /*
        {
            "title": "UCSD Shiley Eye Institute, Jacobs Retina Center",
            "lat": 32.8801,
            "lng": -117.2359,
            "address": "9415 Campus Point Drive, La Jolla, California, 92093, USA"
        },
        */
        {
            "title": "Retina Center of Texas",
            "lat": 32.9362,
            "lng": -97.1204,
            "address": "305 Morrison Park Drive, Suite 100, Southlake, Texas, 76092, USA"
        },
        {
            "title": "University of Washington Medical Center",
            "lat": 47.6519,
            "lng": -122.3067,
            "address": "908 Jefferson, Suite 1191, Seattle, Washington, 98104, USA"
        },
        {
            "title": "Vitreoretinal Associates of Washington",
            "lat": 47.6263,
            "lng": -122.2004,
            "address": "1750 112th Avenue NE, Suite D-050, Bellevue, Washington, 98004, USA"
        },
        /*
        {
            "title": "Cleveland Clinic, Cole Eye Institute",
            "lat": 41.5023,
            "lng": -81.6226,
            "address": "9500 Euclid Avenue, I-32, Cleveland, Ohio, 44195, USA"
        },
        */
        {
            "title": "University of Illinois at Chicago - Specialty Care Building",
            "lat": 41.8719,
            "lng": -87.6545,
            "address": "1855 West Taylor Street, Room 2.178, Chicago, Illinois, 60612, USA"
        },
        /*
        {
            "title": "Bascom Palmer Eye Institute - Ophthalmology - Miami",
            "lat": 25.7903,
            "lng": -80.2149,
            "address": "900 NW 17th St, Miami, Florida, 33136, USA"
        },
        {
            "title": "Moran Eye Center - University of Utah",
            "lat": 40.7650,
            "lng": -111.8410,
            "address": "65 Mario Capecchi Drive, Salt Lake City, Utah, 84132, USA"
        },
        
        {
            "title": "UCSF Ocular Oncology Clinic",
            "lat": 37.7633,
            "lng": -122.3918,
            "address": "490 Illinois St, San Francisco, California, 94158, USA"
        },
        */
        // {
        //     "title": "Colorado Retina Associates",
        //     "lat": 39.6965,
        //     "lng": -105.1087,
        //     "address": "255 S. Routt Street, Suite 200, Lakewood, Colorado, 80228, USA"
        // },
        {
            "title": "Cleveland Clinic, Cole Eye Institute",
            "lat": 41.5034, 
            "lng": -81.6196,
            "address": "9500 Euclid Avenue, I-32, Cleveland, Ohio, 44195, USA",
        },{
            "title": "Bascom Palmer Eye Institute - Ophthalmology - Miami",
            "lat": 25.7925,
            "lng": -80.2124,
            "address": "900 NW 17th St, Miami, Florida, 33136, USA",
        },{
            "title": "UCSD Shiley Eye Institute, Jacobs Retina Center",
            "lat": 32.8801,
            "lng": -117.2359,
            "address": "9415 Campus Point Drive, La Jolla, California, 92093, USA"
        },
        {
            "title": "Southeastern Retina Associates",
            "lat": 35.1380817476279, 
            "lng": -85.24055145825429,
            "address": "1961 Northpoint Blvd., Ste 110, Hixson, TN 37343, USA"
        },

    ]

    newsites.forEach(site => {
        sites.push(new googleMapObj.maps.Marker({
            active: true,
            title: site.title,
            site_no: "1001",
            address: site.address, // Add the address property
            email: "",
            position: {
                lat: site.lat,
                lng: site.lng,
            },
            icon: icon,
            map: mapObj,
        }));
    });
    return sites;
};

/* ================= Eligibility form  ===================== */
export const answers = {
    YES: "yes_a",
    NO: "no_a",
    //MAYBE: "maybe_a",
    UNKNOWN: "unknown_a",
    NA: "na_a",
    // DONTKNOW: "dk_a",
};

export const eligibilityForm = (context) => [

    // Question 1
    {
        question: context.$t("question1"),
        field_name: context.$t("question1", 'en'),
        choices: [{
            value: answers.YES,
            text: context.$t("yes_a"),
            englishValue: context.$t("yes_a", 'en')
        },
        {
            value: answers.NO,
            text: context.$t("no_a"),
            englishValue: context.$t("no_a", 'en')
        },
        ],
        correctAnswers: [answers.YES],
    },

    // Question 2
    {
        question: context.$t("question2"),
        field_name: context.$t("question2", 'en'),
        choices: [{
            value: answers.YES,
            text: context.$t("yes_a"),
            englishValue: context.$t("yes_a", 'en')
        },
        {
            value: answers.NO,
            text: context.$t("no_a"),
            englishValue: context.$t("no_a", 'en')
        },
        {
            value: answers.UNKNOWN,
            text: context.$t("unknown_a"),
            englishValue: context.$t("unknown_a", 'en')
        },
        ],
        correctAnswers: [answers.YES, answers.UNKNOWN],
    },

    // Question 3
    {
        question: context.$t("question3"),
        field_name: context.$t("question3", 'en'),
        choices: [{
            value: answers.YES,
            text: context.$t("yes_a"),
            englishValue: context.$t("yes_a", 'en')
        },
        {
            value: answers.NO,
            text: context.$t("no_a"),
            englishValue: context.$t("no_a", 'en')
        },
        {
            value: answers.UNKNOWN,
            text: context.$t("unknown_a"),
            englishValue: context.$t("unknown_a", 'en')
        },
        ],
        correctAnswers: [answers.NO, answers.UNKNOWN],
    },

    // Question 4
    {
        question: context.$t("question4"),
        field_name: context.$t("question4", 'en'),
        choices: [{
            value: answers.YES,
            text: context.$t("yes_a"),
            englishValue: context.$t("yes_a", 'en')
        },
        {
            value: answers.NO,
            text: context.$t("no_a"),
            englishValue: context.$t("no_a", 'en')
        },
        {
            value: answers.UNKNOWN,
            text: context.$t("unknown_a"),
            englishValue: context.$t("unknown_a", 'en')
        },
        ],
        correctAnswers: [answers.NO, answers.UNKNOWN],
    },

    // Question 5
    {
        question: context.$t("question5"),
        field_name: context.$t("question5", 'en'),
        choices: [{
            value: answers.YES,
            text: context.$t("yes_a"),
            englishValue: context.$t("yes_a", 'en')
        },
        {
            value: answers.NO,
            text: context.$t("no_a"),
            englishValue: context.$t("no_a", 'en')
        }, {
            value: answers.UNKNOWN,
            text: context.$t("unknown_a"),
            englishValue: context.$t("unknown_a", 'en')
        },
        ],
        correctAnswers: [answers.NO, answers.UNKNOWN],
    },

    // Question 6
    {
        question: context.$t("question6"),
        field_name: context.$t("question6", 'en'),
        choices: [{
            value: answers.YES,
            text: context.$t("yes_a"),
            englishValue: context.$t("yes_a", 'en')
        },
        {
            value: answers.NO,
            text: context.$t("no_a"),
            englishValue: context.$t("no_a", 'en')
        }, {
            value: answers.NA,
            text: context.$t("na_a"),
            englishValue: context.$t("na_a", 'en')
        },
        ],
        correctAnswers: [answers.NO, answers.NA],
    },
];


/* ================= Patient Connect Sites (Type One)  ===================== */
import ireland from "@/sites/ireland.js";
export const sites = [{
    id: "ie",
    name: "Ireland",
    states: ireland,
},
    /*
    {
        id: "us",
        name: "United States",
        states: usa,
    },
    */
];

/* ================= Patient Connect Sites (Type Two)  ===================== */

import australiaTwo from "@/sites/australiaTwo.js";
import austriaTwo from "@/sites/austriaTwo.js";
/*
import canadaTwo from "@/sites/canadaTwo.js";
import czechTwo from "@/sites/czechTwo.js";
import denmarkTwo from "@/sites/denmarkTwo.js";
import finlandTwo from "@/sites/finlandTwo.js";
import franceTwo from "@/sites/franceTwo.js";
import germanyTwo from "@/sites/germanyTwo.js";
import greeceTwo from "@/sites/greeceTwo.js";
import koreaTwo from "@/sites/koreaTwo.js";
import spainTwo from "@/sites/spainTwo.js";
import irelandTwo from "@/sites/irelandTwo.js";
*/
import belgiumTwo from "@/sites/belgiumTwo.js";
import ukTwo from "@/sites/ukTwo.js";
import canadaTwo from "@/sites/canadaTwo.js";
import usTwo from "@/sites/usTwo.js";
import spainTwo from "./sites/spainTwo";
import czechTwo from "@/sites/czechTwo.js";
import netherlandsTwo from "@/sites/netherlandsTwo.js";
import newzealand from "./sites/newzealand";
import germanyTwo from "@/sites/germanyTwo.js";
import italyTwo from "@/sites/italyTwo.js";
import israelTwo from "@/sites/israelTwo.js";

export const sitesTwo = [
    
    {
        id: "au",
        name: "Australia",
        states: australiaTwo,
    },
    {
        id: "au",
        name: "Austria",
        states: austriaTwo,
    },
    {
        id: "be",
        name: "Belgium",
        states: belgiumTwo,
    },
    {
        id: "ca",
        name: "Canada",
        states: canadaTwo,
    },
    {
        id: "cz",
        name: "Czech Republic",
        states: czechTwo,
    },
    {
        id: "nl",
        name: "Netherlands",
        states: netherlandsTwo,
    },
    {
        id: "nz",
        name: "New Zealand",
        states: newzealand,
    },
    {
        id: "de",
        name: "Germany",
        states: germanyTwo,
    },
    /*
    {
        id: "at",
        name: "Austria",
        states: austriaTwo,
    },
    {
        id: "ca",
        name: "Canada",
        states: canadaTwo,
    },
    {
        id: "dk",
        name: "Denmark",
        states: denmarkTwo,
    },
    {
        id: "fi",
        name: "Finland",
        states: finlandTwo,
    },
    {
        id: "fr",
        name: "France",
        states: franceTwo,
    },
    {
        id: "gr",
        name: "Greece",
        states: greeceTwo,
    },
    {
        id: "ie",
        name: "Ireland",
        states: irelandTwo,
    },
    {
        id: "kr",
        name: "Korea",
        states: koreaTwo,
    },
    */
    {
        id: "il",
        name: "Israel",
        states: israelTwo,
    },
    {
        id: "it",
        name: "Italy",
        states: italyTwo,
    },
    {
        id: "es",
        name: "Spain",
        states: spainTwo,
    },
    {
        id: "uk",
        name: "United Kingdom",
        states: ukTwo,
    },
    
    {
        id: "us",
        name: "United States",
        states: usTwo,
    },
   
    
];
